import { HFlow, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { masks } from 'util/mask'
import { applyMask } from 'util/mask/applyMask'

import { ResponsavelFamiliarSelectFieldModel } from './ResponsavelFamiliarSelectField'

interface ResponsavelFamiliarSelectItemProps {
  item: ResponsavelFamiliarSelectFieldModel
}

export const ResponsavelFamiliarSelectItem = ({ item }: ResponsavelFamiliarSelectItemProps) => {
  if (!item) return null

  return (
    <VFlow vSpacing={0}>
      <Text fontWeight='bold'>{item.nomeSocial || item.nome}</Text>
      <HFlow>
        <HLabel title='CPF'>{item.cpf && applyMask(item.cpf, masks.cpf)}</HLabel>
        <HLabel title='CNS'>{item.cns}</HLabel>
      </HFlow>
    </VFlow>
  )
}
